<template>
      <div class="text-field">
        <div class="text-field__prepend-outer">
          <slot name="prepend"></slot>
        </div>
        <div class="text-field__control">
          <div class="text-field__label">
            <slot name="label">{{label}}</slot>
          </div>
          <div class="text-field__content" :class="{pre: pre}"><slot>{{content}}</slot></div>
        </div>
      </div>
</template>
<script>
export default {
  props: {
    content: String,
    label: String,
    pre: Boolean
  }
}
</script>
<style>
.text-field__content.pre {
  white-space: pre-line;
}
</style>



// WEBPACK FOOTER //
// src/utils/TextField.vue